import { SpoilerViewerWrapper } from "./Components/Wrappers/spoiler-viewer-wrapper.js";
import nodeViewDecorator from "./node-view-decorator.js";
import { SPOILER_TYPE } from "./types.js";
import { initSpoilersContentState } from "./utils/spoiler-utils-fn.js";
const pluginSpoiler = (config) => {
  return {
    config: { initSpoilersContentState, SpoilerViewerWrapper, ...config },
    type: SPOILER_TYPE,
    nodeViewDecorators: [nodeViewDecorator]
  };
};
export {
  SpoilerViewerWrapper,
  initSpoilersContentState,
  pluginSpoiler
};
//# sourceMappingURL=viewer.js.map
